import type { Template } from "@/types";

export const PO_07_H4_V3: Template[] = [
    {
        id: "po-07-h4v3-01",
        name: "PO 01 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_01.png",      
        size: [1311, 820],
        style: {},
        slots: [       
            { id: "1", x: 50, y: 228, width: 275, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 415, width: 275, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 333, y: 228, width: 274, height: 179, rotation: 0, imageRotation: 0 },
            { id: "4", x: 333, y: 415, width: 274, height: 179, rotation: 0, imageRotation: 0 },
            { id: "5", x: 706, y: 157, width: 367, height: 508, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1081, y: 157, width: 179, height: 250, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1081, y: 415, width: 179, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-02",
        name: "PO 02 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 63, y: 156, width: 531, height: 335, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 498, width: 262, height: 165, rotation: 0, imageRotation: 0 },
            { id: "3", x: 333, y: 498, width: 261, height: 165, rotation: 0, imageRotation: 0 },
            { id: "4", x: 707, y: 108, width: 554, height: 347, rotation: 0, imageRotation: 0 },
            { id: "5", x: 707, y: 462, width: 180, height: 249, rotation: 0, imageRotation: 0 },
            { id: "6", x: 895, y: 462, width: 179, height: 249, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1082, y: 462, width: 179, height: 249, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-03",
        name: "PO 03 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 50, y: 238, width: 554, height: 345, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 706, y: 238, width: 180, height: 110, rotation: 0, imageRotation: 0 },
            { id: "3", x: 706, y: 356, width: 180, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 706, y: 474, width: 180, height: 109, rotation: 0, imageRotation: 0 },
            { id: "5", x: 893, y: 238, width: 233, height: 345, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1134, y: 238, width: 126, height: 169, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1134, y: 415, width: 126, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-04",
        name: "PO 04 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_04.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 51, y: 156, width: 554, height: 382, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 51, y: 545, width: 180, height: 120, rotation: 0, imageRotation: 0 },
            { id: "3", x: 239, y: 545, width: 179, height: 120, rotation: 0, imageRotation: 0 },
            { id: "4", x: 426, y: 545, width: 179, height: 120, rotation: 0, imageRotation: 0 },
            { id: "5", x: 686, y: 133, width: 395, height: 554, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1089, y: 133, width: 190, height: 273, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1089, y: 414, width: 190, height: 273, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-05",
        name: "PO 05 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_05.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 96, y: 196, width: 462, height: 279, rotation: 0, imageRotation: 0 },    
            { id: "2", x: 96, y: 482, width: 228, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 482, width: 227, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 776, y: 196, width: 416, height: 232, rotation: 0, imageRotation: 0 },
            { id: "5", x: 775, y: 435, width: 134, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 917, y: 435, width: 134, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1059, y: 435, width: 133, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-06",
        name: "PO 06 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_06.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 50, y: 186, width: 556, height: 320, rotation: 0, imageRotation: 0 },
            { id: "2", x: 737, y: 186, width: 318, height: 448, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 513, width: 180, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 238, y: 513, width: 180, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 426, y: 513, width: 180, height: 122, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1063, y: 186, width: 150, height: 220, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1063, y: 414, width: 150, height: 220, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-07",
        name: "PO 07 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_07.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 29, y: 218, width: 597, height: 384, rotation: 0, imageRotation: 0 },
            { id: "2", x: 682, y: 218, width: 197, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 682, y: 349, width: 197, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 682, y: 480, width: 197, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 886, y: 218, width: 262, height: 384, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1155, y: 218, width: 124, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1155, y: 414, width: 124, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-08",
        name: "PO 08 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_08.png",
        size: [1311, 820],
        style: {},
        slots: [       
            { id: "1", x: 0, y: 225, width: 260, height: 369, rotation: 0, imageRotation: 0 },    
            { id: "2", x: 268, y: 225, width: 253, height: 181, rotation: 0, imageRotation: 0 },
            { id: "3", x: 268, y: 414, width: 253, height: 180, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 225, width: 253, height: 369, rotation: 0, imageRotation: 0 },
            { id: "5", x: 790, y: 225, width: 253, height: 181, rotation: 0, imageRotation: 0 },
            { id: "6", x: 790, y: 414, width: 253, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1051, y: 225, width: 260, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-09",
        name: "PO 09 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_09.png",
        size: [1311, 820],
        style: {},
        slots: [    
            { id: "1", x: 0, y: 225, width: 260, height: 181, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 414, width: 260, height: 180, rotation: 0, imageRotation: 0 },
            { id: "3", x: 268, y: 225, width: 253, height: 369, rotation: 0, imageRotation: 0 },
            { id: "4", x: 529, y: 225, width: 253, height: 369, rotation: 0, imageRotation: 0 },
            { id: "5", x: 790, y: 225, width: 253, height: 369, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1051, y: 225, width: 260, height: 181, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1051, y: 414, width: 260, height: 180, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h4v3-10",
        name: "PO 10 - H4V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h4_v3_10.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 117, y: 125, width: 465, height: 282, rotation: 0, imageRotation: 0 },
            { id: "2", x: 117, y: 415, width: 465, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 590, y: 125, width: 465, height: 282, rotation: 0, imageRotation: 0 },
            { id: "4", x: 590, y: 415, width: 465, height: 281, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1062, y: 125, width: 134, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1062, y: 318, width: 134, height: 185, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1062, y: 511, width: 134, height: 185, rotation: 0, imageRotation: 0 }
        ],
    }
];